import React, { useState } from 'react';
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { DataTable } from '../components/DataTable';
import { KPICard } from '../components/KPICard';
import { DemographicPyramid } from '../components/DemographicPyramid';
import { TabView } from '../components/TabView';
import { mockVitalStatisticsData, mockVitalRecords } from '../data/mockData';
const VitalStatisticsReport = () => {
  const [view, setView] = useState('dashboard');
  const birthsDeathsData = mockVitalStatisticsData.birthsDeathsOverTime;
  const marriagesByJurisdiction = mockVitalStatisticsData.marriagesByJurisdiction;
  const columns = [{
    header: 'Record ID',
    accessor: 'id'
  }, {
    header: 'Record Type',
    accessor: 'recordType'
  }, {
    header: 'Date',
    accessor: 'date'
  }, {
    header: 'Jurisdiction',
    accessor: 'jurisdiction'
  }, {
    header: 'Gender',
    accessor: 'gender'
  }, {
    header: 'Age',
    accessor: 'age'
  }];
  return <div className="p-6" data-id="element-314">
      <div className="flex justify-between items-center mb-6" data-id="element-315">
        <h1 className="text-2xl font-bold" data-id="element-316">Vital Statistics Report</h1>
        <TabView tabs={[{
        id: 'dashboard',
        label: 'Dashboard'
      }, {
        id: 'data',
        label: 'Detailed Data'
      }]} activeTab={view} onChange={setView} data-id="element-317" />
      </div>
      {view === 'dashboard' ? <>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-318">
            <KPICard title="Total Births" value={mockVitalStatisticsData.totalBirths} change="+2.3%" isPositive={true} icon="baby" color="blue" data-id="element-319" />
            <KPICard title="Total Deaths" value={mockVitalStatisticsData.totalDeaths} change="-1.5%" isPositive={false} icon="activity" color="red" data-id="element-320" />
            <KPICard title="Total Marriages" value={mockVitalStatisticsData.totalMarriages} change="+4.7%" isPositive={true} icon="heart" color="green" data-id="element-321" />
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-322">
            <div className="bg-white p-4 rounded-lg shadow" data-id="element-323">
              <h2 className="text-lg font-semibold mb-4" data-id="element-324">
                Births vs Deaths Over Time
              </h2>
              <ResponsiveContainer width="100%" height={300} data-id="element-325">
                <LineChart data={birthsDeathsData} data-id="element-326">
                  <CartesianGrid strokeDasharray="3 3" data-id="element-327" />
                  <XAxis dataKey="month" data-id="element-328" />
                  <YAxis data-id="element-329" />
                  <Tooltip data-id="element-330" />
                  <Legend data-id="element-331" />
                  <Line type="monotone" dataKey="births" stroke="#3b82f6" name="Births" data-id="element-332" />
                  <Line type="monotone" dataKey="deaths" stroke="#ef4444" name="Deaths" data-id="element-333" />
                </LineChart>
              </ResponsiveContainer>
            </div>
            <div className="bg-white p-4 rounded-lg shadow" data-id="element-334">
              <h2 className="text-lg font-semibold mb-4" data-id="element-335">
                Marriages by Jurisdiction
              </h2>
              <ResponsiveContainer width="100%" height={300} data-id="element-336">
                <BarChart data={marriagesByJurisdiction} data-id="element-337">
                  <CartesianGrid strokeDasharray="3 3" data-id="element-338" />
                  <XAxis dataKey="jurisdiction" data-id="element-339" />
                  <YAxis data-id="element-340" />
                  <Tooltip data-id="element-341" />
                  <Legend data-id="element-342" />
                  <Bar dataKey="marriages" fill="#3b82f6" name="Marriages" data-id="element-343" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
          <div className="bg-white p-4 rounded-lg shadow mb-8" data-id="element-344">
            <h2 className="text-lg font-semibold mb-4" data-id="element-345">Age Distribution</h2>
            <DemographicPyramid data={mockVitalStatisticsData.demographicData} data-id="element-346" />
          </div>
        </> : <div className="bg-white p-4 rounded-lg shadow" data-id="element-347">
          <h2 className="text-lg font-semibold mb-4" data-id="element-348">Vital Records</h2>
          <DataTable columns={columns} data={mockVitalRecords} pagination searchable exportable data-id="element-349" />
        </div>}
    </div>;
};
export default VitalStatisticsReport;